import React from 'react';
import { ContactContainer } from '../../container';

const ContactPage = () => {
  return (
    <div>
      <ContactContainer />
    </div>
  );
};

export default ContactPage;
